import * as actions from './actions'
import { success, failure } from 'utilities/actions'

import type { Organisation, CustomFollowUpLabel } from 'types'
import type { Action } from './types'

export type State = {
  data: CustomFollowUpLabel[];
  errors: any[];
  savingCustomFollowUpLabel: boolean;
  savedCustomFollowUpLabel: boolean;
  organisations: Organisation[];
};

const initialState = {
  data: [],
  errors: [],
  savingCustomFollowUpLabel: false,
  savedCustomFollowUpLabel: false,
  organisations: []
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly data: readonly []; readonly errors: readonly []; readonly savingCustomFollowUpLabel: false; readonly savedCustomFollowUpLabel: false; readonly organisations: readonly []; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  const { data = [], errors } = action
  switch (action.type) {
// @ts-expect-error - TS2678 - Type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX_SUCCESS"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case success(actions.FETCH_FOLLOW_UP_LABELS):
      return { ...state, data }
    case actions.CREATE_FOLLOW_UP_LABEL:
    case actions.UPDATE_FOLLOW_UP_LABEL:
      return {
        ...state,
        savingCustomFollowUpLabel: true,
        savedCustomFollowUpLabel: false
      }
// @ts-expect-error - TS2678 - Type '"API_CUSTOM_FOLLOW_UP_LABELS_CREATE_SUCCESS"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case success(actions.CREATE_FOLLOW_UP_LABEL):
// @ts-expect-error - TS2678 - Type '"API_CUSTOM_FOLLOW_UP_LABELS_UPDATE_SUCCESS"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case success(actions.UPDATE_FOLLOW_UP_LABEL):
      return {
        ...state,
        data,
        savingCustomFollowUpLabel: false,
        savedCustomFollowUpLabel: true
      }
// @ts-expect-error - TS2678 - Type '"FETCH_TOP_ORGANISATIONS_SUCCESS"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case success(actions.FETCH_TOP_ORGANISATIONS):
      const { data: organisations = [] } = action

      return { ...state, organisations }
// @ts-expect-error - TS2678 - Type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX_FAILURE"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case failure(actions.FETCH_FOLLOW_UP_LABELS):
// @ts-expect-error - TS2678 - Type '"FETCH_TOP_ORGANISATIONS_FAILURE"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case failure(actions.FETCH_TOP_ORGANISATIONS):
      return { ...state, errors }
// @ts-expect-error - TS2678 - Type '"API_CUSTOM_FOLLOW_UP_LABELS_CREATE_FAILURE"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case failure(actions.CREATE_FOLLOW_UP_LABEL):
// @ts-expect-error - TS2678 - Type '"API_CUSTOM_FOLLOW_UP_LABELS_UPDATE_FAILURE"' is not comparable to type '"API_CUSTOM_FOLLOW_UP_LABELS_INDEX" | "API_CUSTOM_FOLLOW_UP_LABELS_CREATE" | "API_CUSTOM_FOLLOW_UP_LABELS_UPDATE"'. - fall through
    case failure(actions.UPDATE_FOLLOW_UP_LABEL):
      return {
        ...state,
        savingCustomFollowUpLabel: false,
        savedCustomFollowUpLabel: false,
        errors
      }
    default:
      return state
  }
}

export default reducer
